import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const Action = ({ onBookDemo }) => {
  return (
    <section className="action" id="demo" aria-labelledby="action-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} md={10} lg={8} xl={7}>
            <h2 id="action-heading" className="action__title">
              See Lien Logic in action.
            </h2>
            <p className="action__description mx-auto">
              Book a 20-minute walkthrough before your next intake meeting.
            </p>
            <Button type="button" className="action__btn" onClick={onBookDemo}>
              Book a Demo
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Action;
